const pages = ['SSN', 'Terms and Conditions','Mobile Number','Enter One Time Passcode', 'Create Online ID', 'Create Password'];

export default pages;